export default __webpack_public_path__ + "build/66eb8a633937ea94ae9ea6199ce5d9f1.jpg";